import React, { useState } from 'react';
import './RentAsics.css';
import '../../components/Contact/Contact.css';
import '../../components/Faq/Faq.css';
import '../../components/Disclaimer/Disclaimer.css';
import '../../components/Button/Button.css';

const RentAsics = ({ onNavigateToDetails }) => {
  const [expandedFaq, setExpandedFaq] = useState({});
  const [showHostingFee, setShowHostingFee] = useState(false);

  // Hardcoded ASIC models
  const asicModels = [
    {
      id: 1,
      name: 'Bitmain Antminer',
      model: 'S21 XP Hyd',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$2,190', price: '$1,825', soldOut: false, link: '/rent-asic-details/1?duration=365' },
        { months: 18, miningOutput: '$3,285', price: '$2,737', soldOut: false, link: '/rent-asic-details/1?duration=547' },
        { months: 24, miningOutput: '$4,380', price: '$3,650', soldOut: false, link: '/rent-asic-details/1?duration=730' }
      ],
      image: '/images/asic-miner.png'
    },
    {
      id: 2,
      name: 'Bitmain Antminer',
      model: 'S21 Pro',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$1,460', price: '$1,216', soldOut: false, link: '/rent-asic-details/2?duration=365' },
        { months: 18, miningOutput: '$2,190', price: '$1,825', soldOut: false, link: '/rent-asic-details/2?duration=547' },
        { months: 24, miningOutput: '$2,920', price: '$2,433', soldOut: false, link: '/rent-asic-details/2?duration=730' }
      ],
      image: '/images/asics/S21ProGrey.png'
    },
    {
      id: 3,
      name: 'Bitmain Antminer',
      model: 'S21',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$1,314', price: '$1,095', soldOut: false, link: '/rent-asic-details/3?duration=365' },
        { months: 18, miningOutput: '$1,971', price: '$1,642', soldOut: false, link: '/rent-asic-details/3?duration=547' },
        { months: 24, miningOutput: '$2,628', price: '$2,190', soldOut: false, link: '/rent-asic-details/3?duration=730' }
      ],
      image: '/images/asic-miner.png'
    },
    {
      id: 4,
      name: 'Bitmain Antminer',
      model: 'S19k Pro',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$876', price: '$730', soldOut: false, link: '/rent-asic-details/4?duration=365' },
        { months: 18, miningOutput: '$1,314', price: '$1,095', soldOut: false, link: '/rent-asic-details/4?duration=547' },
        { months: 24, miningOutput: '$1,752', price: '$1,460', soldOut: false, link: '/rent-asic-details/4?duration=730' }
      ],
      image: '/images/asic-miner.png'
    },
    {
      id: 5,
      name: 'Bitmain Antminer',
      model: 'T21',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$1,168', price: '$973', soldOut: false, link: '/rent-asic-details/5?duration=365' },
        { months: 18, miningOutput: '$1,752', price: '$1,460', soldOut: false, link: '/rent-asic-details/5?duration=547' },
        { months: 24, miningOutput: '$2,336', price: '$1,946', soldOut: false, link: '/rent-asic-details/5?duration=730' }
      ],
      image: '/images/asic-miner.png'
    },
    {
      id: 6,
      name: 'Bitmain Antminer',
      model: 'S19 XP Hyd',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7797_46260)">
            <rect x="0.43125" y="0.525" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749" stroke="#1570EF" strokeWidth="1.16875" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7797_46260">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      plans: [
        { months: 12, miningOutput: '$949', price: '$791', soldOut: false, link: '/rent-asic-details/6?duration=365' },
        { months: 18, miningOutput: '$1,423', price: '$1,186', soldOut: false, link: '/rent-asic-details/6?duration=547' },
        { months: 24, miningOutput: '$1,898', price: '$1,581', soldOut: false, link: '/rent-asic-details/6?duration=730' }
      ],
      image: '/images/asic-miner.png'
    }
  ];

  const loading = false;

  const toggleFaq = (index) => {
    setExpandedFaq(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqQuestions = [
    'What Is ASIC Miner Rental?',
    'What Are the Costs Involved in ASIC Miner Rental?',
    'How to Rent an ASIC Miner?',
    'What Is the Difference Between Post-Payment and Prepayment Fees?',
    'Where Will the Rented ASIC Miner Be Located?',
    'How Do I Claim and Monitor My Rewards?',
    'How Can I Estimate the Income From ASIC Miner Rental?',
    'How is ASIC Miner Rental Different From Buying?'
  ];

  const scrollToRent = () => {
    const element = document.getElementById('rent');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="asics holder">
      {/* Header Section */}
      <div className="rent-asic__container">
        <div className="rent-asic__head-title-block">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6330_32693)">
              <rect x="0.43125" y="1.025" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
              <path d="M7.7062 7H16.2937C16.3928 7.00017 16.4897 7.0298 16.572 7.08515C16.6542 7.14049 16.7182 7.21904 16.7557 7.31081C16.7932 7.40259 16.8026 7.50344 16.7826 7.60056C16.7627 7.69768 16.7143 7.78668 16.6437 7.85625L11.9999 12.5L7.3562 7.85625C7.28555 7.78668 7.23719 7.69768 7.21725 7.60056C7.19731 7.50344 7.20669 7.40259 7.2442 7.31081C7.28172 7.21904 7.34567 7.14049 7.42793 7.08515C7.51019 7.0298 7.60705 7.00017 7.7062 7V7Z" stroke="#1570EF" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M7.7062 18H16.2937C16.3928 17.9998 16.4897 17.9702 16.572 17.9149C16.6542 17.8595 16.7182 17.781 16.7557 17.6892C16.7932 17.5974 16.8026 17.4966 16.7826 17.3994C16.7627 17.3023 16.7143 17.2133 16.6437 17.1438L11.9999 12.5L7.3562 17.1438C7.28555 17.2133 7.23719 17.3023 7.21725 17.3994C7.19731 17.4966 7.20669 17.5974 7.2442 17.6892C7.28172 17.781 7.34567 17.8595 7.42793 17.9149C7.51019 17.9702 7.60705 17.9998 7.7062 18Z" stroke="#1570EF" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M8.5 9H15.5" stroke="#1570EF" strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
            <defs>
              <clipPath id="clip0_6330_32693">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)"></rect>
              </clipPath>
            </defs>
          </svg>
          <p className="rent-asic__head-title">Rent Asics</p>
        </div>

        <div className="rent-asic__header">
          <div className="rent-asic__rent-header">
            <ul className="rent-asic__rent-header-block">
              <li className="rent-asic__rent-header-title">Rent the latest ASIC models and start mining within 24 hours</li>
              <li className="rent-asic__rent-header-title">Flexible rental periods: from 12 to 24 months</li>
              <li className="rent-asic__rent-header-title">Flexible hosting fee payment schedule: daily or monthly</li>
              <li className="rent-asic__rent-header-title">Benefit from nearly 100% uptime at FX-Pool Data Center</li>
              <li className="rent-asic__rent-header-title">Pay only a one-time rental price along with regular hosting fee</li>
            </ul>
          </div>
        </div>
      </div>

      {/* ASIC Rental Deals Section */}
      <div className="rent-asic__asic" id="rent">
        <div className="rent-asic__title-block">
          <h1 className="rent-asic__title">ASIC Rental Deals</h1>
          <p className="rent-asic__subtitle">Choose the rental package that suits you best!</p>
        </div>

        <div className="rent-asic__models-block-bottom">
          {loading ? (
            <div className="loading-message" style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Loading ASIC models...</p>
            </div>
          ) : asicModels.length === 0 ? (
            <div className="no-models-message" style={{ textAlign: 'center', padding: '2rem' }}>
              <p>No ASIC models available at the moment.</p>
            </div>
          ) : (
            asicModels.map((model, modelIndex) => (
            <div key={modelIndex}>
              <div className="rent-asic__title-group">
                <div className="rent-asic__img">{model.icon}</div>
                <p className="rent-asic__main-part">
                  {model.name} <span className="rent-asic__sub-part">{model.model}</span>
                </p>
              </div>
              <div className="rent-asic__models-card-block">
                {model.plans.map((plan, planIndex) => (
                  <div key={planIndex} className="rent-asic__models-card">
                    {plan.soldOut && (
                      <p className="rent-asic__models-card-fee">Sold Out</p>
                    )}
                    <div className="rent-asic__models-card-title">
                      <div className="rent-asic__models-duration-title-block">
                        <p className="rent-asic__models-duration-title">Months</p>
                        <p className="rent-asic__models-duration-value">{plan.months}</p>
                      </div>
                      <p className="rent-asic__models-duration-subtitle">Rental period</p>
                    </div>
                    <div className="rent-asic__models-card-value">
                      <div className="rent-asic__image-wrapper">
                        <img className="rent-asic__image" src={model.image} alt="asic-image" />
                      </div>
                      <div className="rent-asic__models-info-block">
                        <p className="rent-asic__models-title">Mining Output:</p>
                        <p className="rent-asic__models-info-mining-value">{plan.miningOutput}</p>
                      </div>
                    </div>
                    <div className="rent-asic__models-information">
                      <div className="rent-asic__models-info">
                        <p className="rent-asic__models-info-breakeven-title">Price:</p>
                        <p className="rent-asic__models-info-breakeven-value">{plan.price}</p>
                      </div>
                      <button 
                        className="primary" 
                        type="button" 
                        disabled={plan.soldOut}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!plan.soldOut && onNavigateToDetails) {
                            // Extract ID and duration from link: /rent-asic-details/3?duration=365
                            const urlParts = plan.link.split('/');
                            const lastPart = urlParts[urlParts.length - 1]; // "3?duration=365"
                            const [id, query] = lastPart.split('?'); // ["3", "duration=365"]
                            
                            // Update URL with query parameter
                            window.history.pushState(
                              { page: 'rent-asic-details', asicId: id }, 
                              '', 
                              `/preorder/rent-asic/${lastPart}`
                            );
                            
                            onNavigateToDetails(id);
                          }
                        }}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
          )}
        </div>

        {/* Disclaimer */}
        <div className="disclaimer">
          <p className="disclaimer__title">Disclaimer</p>
          <p className="disclaimer__description">
            These estimates offer forward-looking information based on current data, including mining difficulty: FPPS 0.00000041, and BTC reference rate: $130K (12m), $140K (18m), $155K (24m). They are not guarantees of future results and should be viewed with caution due to market uncertainties.
          </p>
        </div>
      </div>

      {/* Why to Rent Section */}
      <div className="rent">
        <svg xmlns="http://www.w3.org/2000/svg" width="155" height="138" viewBox="0 0 155 138" fill="none" className="rent__img">
          <g clipPath="url(#clip0_7786_43289)">
            <path d="M95.6143 137.857C46.098 137.857 5.81055 97.5699 5.81055 48.0537C5.81055 -1.46254 46.098 -41.75 95.6143 -41.75C145.13 -41.75 185.418 -1.46254 185.418 48.0537C185.418 97.5699 145.13 137.857 95.6143 137.857ZM95.6143 -29.4738C52.8643 -29.4738 18.0867 5.30379 18.0867 48.0537C18.0867 90.8036 52.8643 125.581 95.6143 125.581C138.364 125.581 173.142 90.8036 173.142 48.0537C173.142 5.30379 138.364 -29.4738 95.6143 -29.4738Z" fill="#53B1FD" fillOpacity="0.18"></path>
            <path d="M61.4961 43.0745L88.9974 77.4342L131.777 30.5801" stroke="#53B1FD" strokeOpacity="0.18" strokeWidth="14.9336" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <defs>
            <clipPath id="clip0_7786_43289">
              <rect width="154.437" height="137.859" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
        <h2 className="rent__title">Why to Rent?</h2>
        <div className="rent__faq-section">
          <div className="rent__faq-item">
            <div className="rent__faq-title-block">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2802_49250)">
                    <path d="M7.49951 12L10.4995 15L16.4995 9M21.9995 12C21.9995 17.5228 17.5224 22 11.9995 22C6.47666 22 1.99951 17.5228 1.99951 12C1.99951 6.47715 6.47666 2 11.9995 2C17.5224 2 21.9995 6.47715 21.9995 12Z" stroke="#2E90FA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_2802_49250">
                      <rect width="24" height="24" rx="12" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h3 className="rent__faq-title">Scalability and Adaptability</h3>
            </div>
            <p className="rent__faq-subtitle">Easily switch miners every 12-36 months to stay ahead of market changes.</p>
          </div>
          <div className="rent__faq-item">
            <div className="rent__faq-title-block">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2802_49250)">
                    <path d="M7.49951 12L10.4995 15L16.4995 9M21.9995 12C21.9995 17.5228 17.5224 22 11.9995 22C6.47666 22 1.99951 17.5228 1.99951 12C1.99951 6.47715 6.47666 2 11.9995 2C17.5224 2 21.9995 6.47715 21.9995 12Z" stroke="#2E90FA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_2802_49250">
                      <rect width="24" height="24" rx="12" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h3 className="rent__faq-title">Cost Efficiency</h3>
            </div>
            <p className="rent__faq-subtitle">Access cutting-edge ASIC miners without big upfront costs and further expenses!</p>
          </div>
          <div className="rent__faq-item">
            <div className="rent__faq-title-block">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2802_49250)">
                    <path d="M7.49951 12L10.4995 15L16.4995 9M21.9995 12C21.9995 17.5228 17.5224 22 11.9995 22C6.47666 22 1.99951 17.5228 1.99951 12C1.99951 6.47715 6.47666 2 11.9995 2C17.5224 2 21.9995 6.47715 21.9995 12Z" stroke="#2E90FA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_2802_49250">
                      <rect width="24" height="24" rx="12" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h3 className="rent__faq-title">Testing and Experimentation</h3>
            </div>
            <p className="rent__faq-subtitle">Test various ASIC models and strategies before buying your own hardware.</p>
          </div>
        </div>
      </div>

     

      {/* How to Pay Hosting Fee Section */}
      <div id="rent-asic__product" className="rent-asic__product container-block">
        <div className={`rent-asic__product-title-block ${showHostingFee ? '' : 'no-background'}`}>
          <p className="rent-asic__product-title">How to Pay Hosting Fee?</p>
          <span className="rent-asic__expand-text" onClick={() => setShowHostingFee(!showHostingFee)}>
            Show{' '}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={showHostingFee ? 'rotate-180' : ''}>
              <path d="M16 12L12 16M12 16L8 12M12 16V8M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke="#1570EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </span>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq">
        <div className="faq__title-group">
          <div className="faq__question-block">
            <h2 className="faq__question-more">Frequently Asked Questions</h2>
            <p className="faq__about-rent">Uncover the details of buying an ASIC from FX-Pool</p>
          </div>
        </div>
        <div className="faq__question-group">
          {faqQuestions.map((question, index) => (
            <div key={index} className="faq__question-group">
              <div className="faq__question-title faq__border" onClick={() => toggleFaq(index)}>
                {question}{' '}
                <span className="faq__item-border">
                  <svg className="faq__item-sign" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <line x1="8" y1="2" x2="8" y2="14" stroke="#98a2b3" strokeWidth="2"></line>
                    {expandedFaq[index] ? null : (
                      <line x1="2" y1="8" x2="14" y2="8" stroke="#98a2b3" strokeWidth="2"></line>
                    )}
                  </svg>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RentAsics;

